<template>
  <b-modal id="modal-request-approval" ref="modal" size="lg" title="Staff Approval" @show="setData" :hide-footer="hideButton">
    <b-form>
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-user"></em> To be filled by user</legend>
              <div class="form-row">
                <label class="col-md-3">Date of Request</label>
                <div class="col-md-6 mb-3">
                  {{detail.date_request}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Requester Name</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status of the request</label>
                <div class="col-md-6 mb-3">
                  {{detail.staff_req_type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project allocation</label>
                <div class="col-md-6 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Province assignment</label>
                <div class="col-md-6 mb-3">
                  {{detail.state_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duty station</label>
                <div class="col-md-6 mb-3">
                  {{detail.unit_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Department</label>
                <div class="col-md-6 mb-3">
                  {{detail.section_name}}
                </div>
              </div>
              <legend><em class="fa fa-calendar"></em> Duration of contract</legend>
              <div class="form-row">
                <label class="col-md-3">Duration start</label>
                <div class="col-md-6 mb-3">
                  {{detail.duration_start}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duration end</label>
                <div class="col-md-6 mb-3">
                  {{detail.duration_end}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Remarks</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Equipment request</label>
                <div class="col-md-6 mb-3">
                  {{detail.equipment}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-6 mb-3">
                  {{detail.staff_req_stat_name}}
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.staff_req_stat_id)"></list-supervisor-finish>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";

export default {
  name: "StaffApproval",
  components:{ListSupervisorFinish, ListSupervisor, BModal, BForm}
  ,props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      stat_id:1,
      hideButton:true,
      detail:{},
      list_supervisor:[],
      arr_status:[0]
    }
  },
  methods:{
    handleOk(evt){
      evt.preventDefault()
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.staff.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    setData(){
      setTimeout(()=>{
        this.getDetail()
      }, 100)
    },
    getDetail(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.staff.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
          this.hideButton =  (this.detail.emp_id == this.$store.getters.empId) ? true :false
          if(!this.arr_status.includes(this.detail.staff_req_stat_id)) this.getListSupervisor()
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getListSupervisor(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.staff.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  }
}
</script>